module.exports = __webpack_public_path__ + "img/edge_nature_nature.a6f87fa5.svg";